import { useTranslation } from "react-i18next";
import type ConfirmConstructionStateChangeModalNewProps from "./ConfirmConstructionStateChangeModalNewProps";
import ConstructionStatus from "../../../../types/ConstructionStatus";
import IsaacModal from "../../../../components/isaacModal/IsaacModal";
import styles from "./confirmConstructionStateChangeModalNew.module.scss";
import { Icon, Stack, Text, PrimaryButton, DefaultButton } from "@fluentui/react";

const ConfirmConstructionStateChangeModalNew: React.FunctionComponent<ConfirmConstructionStateChangeModalNewProps> = ({
    open,
    status,
    handleConfirm,
    handleDismiss
}) => {
    const {t} = useTranslation(["constructionCalculations", "common"]);
    const accept = status !== ConstructionStatus.Accepted;
    
    const handleConfirmAction = async (): Promise<void> => {
        if (handleConfirm) {
            handleDismiss();
            await handleConfirm();
        }
    };
    
    return (
        <IsaacModal
          isOpen={open}
          handleDismiss={() => {
            void handleDismiss();
          }}
          containerClassName={styles.container}
          overlay={{className: styles.overlay}}>
          <Stack>
            <Stack verticalAlign="center" horizontalAlign="center">
              <Icon iconName="Warning" className={styles.icon} />
              <Text variant="xLargePlus">
                {accept ? t(`acceptModalQuestion`) : t(`unacceptModalQuestion`)}
              </Text>
            </Stack>
            <Stack
              verticalAlign="center"
              horizontalAlign="center"
              className={styles.body}>
              <Text variant="large">{t(`acceptModalExplanation`)}</Text>
            </Stack>
            <Stack horizontal className={styles.footer}>
              <Stack.Item className={styles.button}>
                <PrimaryButton
                  onClick={() => {
                    void handleConfirmAction();
                  }}
                  text={t("confirm")}
                />
              </Stack.Item>
              <Stack.Item className={styles.button}>
                <DefaultButton onClick={handleDismiss} text={t("cancel")} />
              </Stack.Item>
            </Stack>
          </Stack>
        </IsaacModal>
    );
};

export default ConfirmConstructionStateChangeModalNew;